<template>
  <section class="vendors">
    <div class="container">
      <div class="row">
        <div class="col">
          <loading v-if="loading" class="white-bg shadow-card" />
          <div class="header" v-if="!loading">
            <div class="header-body">
              <h6 class="header-pretitle">Vendor</h6>
              <h1
                class="header-title"
                :class="$route.query.login > 1 ? 'has-vendor-btn' : ''"
              >
                {{ vendor.name }}
                <router-link
                  v-if="$route.query.login > 1"
                  class="btn btn-dark vendors-btn"
                  to="/my-vendors"
                  >My Other Vendors</router-link
                >
              </h1>
              <h6 v-if="vendor.created_at" class="header-pretitle">
                Created: {{ vendor.created_at | fullDate }}
              </h6>
              <vendor-nav />
            </div>
          </div>
          <router-view></router-view>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState } from "vuex";
import { default as VendorNav } from "./partials/Nav";

export default {
  name: "VendorShow",
  components: {
    VendorNav,
  },
  computed: {
    ...mapState(["saving", "loading", "vendors", "modal"]),
    vendor: function () {
      return this.vendors.single;
    },
  },
  destroyed() {
    this.$store.dispatch("vendors/clearVendorData");
  },
};
</script>

<style scoped lang="scss">
.has-vendor-btn {
  padding-right: 138px;
  display: flex;
  align-items: center;
  position: relative;
  word-break: break-word;
  min-height: 42px;
}
.vendors-btn {
  position: absolute;
  letter-spacing: normal;
  top: 0;
  right: 0;
}
</style>
